<template>
  <div class="social-share" ref="socialRef">
    <RoundIconButton
      :icon="share"
      :size="smallscreen ? '1.5rem' : null"
      transparent
      @onClick="socialOpen = !socialOpen"
    />
    <div class="social-share-menu" v-if="socialOpen">
      <button
        v-for="item of $tm(`metaContent.socials`)"
        class="social-share-menu__button"
        :key="item"
        :aria-label="item"
        :icon="icons[item]"
      >
        <ShareNetwork
          :network="item"
          :url="socialUrl"
          :title="$t(`metaContent.${route.params.page}.title`)"
          :description="$t(`metaContent.${route.params.page}.description`)"
        >
          <p>{{ item == "twitter" ? "x" : item }}</p>
        </ShareNetwork>
      </button>
    </div>
  </div>
</template>

<script setup>
import { facebook, twitter, linkedin, share } from "@/assets/icons/icons.js";
import { ref } from "vue";

import RoundIconButton from "./RoundIconButton.vue";
import { useRoute } from "vue-router";
import { onClickOutside } from "@vueuse/core";

defineProps({
  smallscreen: Boolean,
});

// TODO: what should this be?
const socialUrl = window.location.href;
const icons = { facebook, twitter, linkedin };
const socialOpen = ref(false);
const route = useRoute();
const socialRef = ref(null);

onClickOutside(socialRef, () => (socialOpen.value = false));
</script>

<style lang="scss" scoped>
.social-share {
  position: relative;
  display: flex;
  gap: 0.5rem;

  .mobile &,
  .tablet & {
    justify-content: center;
    gap: 1.75rem;

    .social-share-menu {
      &__button {
        border-color: var(--white-100);
      }
    }
  }

  .mobile & {
    :deep(.round-icon-button) {
      width: fit-content;
    }

    .social-share-menu {
      top: unset;
      bottom: toRem(40);
      right: 0;

      &::before {
        top: unset;
        bottom: toRem(-4);
      }
    }
  }

  &-menu {
    position: absolute;
    top: toRem(60);
    right: toRem(10);
    background-color: var(--color-white);
    padding: toRem(20) toRem(15);
    border-radius: 12px;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: toRem(-4);
      right: toRem(15);
      width: toRem(8);
      height: toRem(8);
      transform: rotate(45deg);
      background-color: var(--color-white);
    }

    &__button {
      color: var(--bg-dark);
      @include overlay-m;
      text-align: center;
      width: 100%;
      transition: color 0.3s ease;

      &:hover {
        color: var(--brand-weaker);
      }
    }
  }
}
</style>
